import React from 'react';

import desktopLogo from 'assets/images/lending-usa-logo.png';
import mobileLogo from 'assets/icons/lusa-logo.svg';

const Logo = () => (
  <div className="flex items-center">
    <img
      src={desktopLogo}
      alt="LendingUSA"
      className="hidden sm:block h-8 w-auto"
    />

    <img
      src={mobileLogo}
      alt="LendingUSA"
      className="block sm:hidden h-10 w-auto"
    />
  </div>
);

export default Logo;
